<template>
  <div class="schedule-content" v-html="schedule"></div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Schedule",
  computed: {
    ...mapGetters({
      room: "room/activeRoom"
    }),
    schedule() {
      return this.room.SCHEDULE_CONTENT;
    }
  }
};
</script>
